import React from 'react';
import { ArrowRight } from 'lucide-react';
import { WA_GENERAL, scrollToId } from './constants';
import { trackWhatsAppClick } from '../../utils/analytics';

export const BrandFooter = () => (
  <footer className="relative pt-28 pb-12 overflow-hidden" data-testid="brand-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <h2 className="br-serif text-4xl sm:text-6xl lg:text-7xl font-semibold leading-[1.05] max-w-4xl">
        A sua marca pode ser a <span className="italic text-[var(--br-teal)]">primeira escolha.</span>
      </h2>
      <div className="mt-10 flex flex-col sm:flex-row gap-4">
        <button onClick={() => scrollToId('raio-x')} data-testid="footer-raio-x-cta" className="group inline-flex items-center justify-center gap-3 rounded-full bg-[var(--br-teal)] text-black font-bold px-8 py-4 transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-white">
          Pedir meu Raio-X da Marca <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
        </button>
        <a href={WA_GENERAL} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('brand-footer')} data-testid="footer-whatsapp-link" className="inline-flex items-center justify-center rounded-full border border-white/15 px-8 py-4 font-semibold transition-colors hover:border-[var(--br-teal)] hover:text-[var(--br-teal)]">
          Falar no WhatsApp · (45) 98806-8508
        </a>
      </div>
      <div className="mt-24 pt-8 border-t border-white/10 grid sm:grid-cols-3 gap-6 text-sm text-[var(--br-muted)]">
        <div>
          <p className="br-serif text-lg text-white">Anderson Coutinho</p>
          <p className="br-mono text-[10px] mt-1 text-[var(--br-teal)]">◆ Estrategista de Marca</p>
        </div>
        <p>Coutin · Estratégia, audiovisual e presença digital<br />Foz do Iguaçu · PR</p>
        <div className="sm:text-right space-y-1">
          <a href="https://instagram.com/coutinagencia" target="_blank" rel="noopener noreferrer" className="block hover:text-[var(--br-teal)] transition-colors" data-testid="footer-instagram">@coutinagencia</a>
          <p>© {new Date().getFullYear()} Coutin. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  </footer>
);
